import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';

import {
  provideAnalytics,
  getAnalytics,
  ScreenTrackingService,
  UserTrackingService,
} from '@angular/fire/analytics';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { ReactiveFormsModule } from '@angular/forms';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';
import { TopLevelLayoutModule } from './top-level-layout/top-level-layout.module';
import { TopLevelStructureModule } from './top-level-structure/top-level-structure.module';
import { SharedModule } from './shared/shared.module';
import { HttpRequestInterceptor } from './shared/interceptors/HttpRequestInterceptor.interceptor';
import { LoginWidgetModule } from './login-widget/login-widget.module';
import { CurrentClientService } from './services/current-client.service';
import { ErrorComponent } from './error/error.component';
import { connectAuthEmulator } from '@angular/fire/auth';
import { connectFirestoreEmulator } from '@angular/fire/firestore';
import { connectFunctionsEmulator, getFunctions } from '@angular/fire/functions';
import { CookiesErrorComponent } from './cookies-error/cookies-error.component';

const appInitializerFn = (currentClientService: CurrentClientService) => {
  return async () => {
    if (environment.useEmulators) {
      
      const auth = getAuth();
      connectAuthEmulator(auth, 'http://localhost:9099');

      const firestore = getFirestore();
      connectFirestoreEmulator(firestore, 'localhost', 8080);

      const functions = getFunctions();
      connectFunctionsEmulator(functions, 'localhost', 5001);
    }
    await currentClientService.init();
  };
};

// uncomment for verbose debug infomation
// import firebase from 'firebase/compat/app';
// firebase.firestore.setLogLevel('debug');

@NgModule({
  declarations: [AppComponent, ErrorComponent, CookiesErrorComponent],
  bootstrap: [AppComponent],
  imports: [
    LoginWidgetModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    SharedModule,
    TopLevelStructureModule,
    TopLevelLayoutModule,
  ],
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    ScreenTrackingService,
    UserTrackingService,
        {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    // interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [CurrentClientService],
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
